module.exports = __webpack_public_path__ + "img/hr-tank-base-shadow-2.138af3a6.png";